import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class QualityDocumentService {
    static getQualityDocuments(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`quality-documents?filter=${qs}`, pageNumber));
    }
    static fetchQualityDocument(oid) {
        return lastValueFrom(BaseService.get(`quality-documents/${oid}`));
    }
    static saveQualityDocument(dto) {
        return lastValueFrom(BaseService.save(`quality-documents`, dto));
    }
    static deleteQualityDocument(oid) {
        return lastValueFrom(BaseService.delete(`quality-documents/${oid}`));
    }
}
